<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addZone()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'NEW' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showZones()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-zone-list
          [zones]="zones"
          [meta]="meta"
          [loadingZones]="loadingZones"
          [defaultLanguage]="defaultLanguage"
          (selectedZone)="onSelectedZone($event)"
        ></app-zone-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-spinner *ngIf="!zone"></app-spinner>
      <div *ngIf="zone">
        <app-zone-detail
          [zone]="zone"
          [mode]="mode"
          [defaultLanguage]="defaultLanguage"
          [additionalLanguages]="additionalLanguages"
          [isModal]="true"
          (savedZone)="onSavedZone($event)"
          (canceledZone)="onCanceledZone()"
        ></app-zone-detail>
      </div>
    </div>
  </div>
</div>
